import { makeStyles } from '@material-ui/core/styles';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowLeftIcon from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import { formatVariableValue, switchUtil } from '@timeflies/common';
import React from 'react';
import { UIText } from '../ui-text/ui-text';
var useStyles = makeStyles(function (_a) {
    var palette = _a.palette;
    return ({
        root: function (_a) {
            var variableName = _a.variableName, colored = _a.colored;
            return ({
                color: colored ? palette.variables[variableName] : undefined,
            });
        },
    });
});
export var VariableValue = function (_a) {
    var variableName = _a.variableName, value = _a.value, relative = _a.relative, colored = _a.colored;
    var classes = useStyles({ variableName: variableName, colored: colored });
    var formattedValue = formatVariableValue(variableName, value, { relative: relative });
    var renderNull = function () { return null; };
    var renderNumeric = function () { return (React.createElement(UIText, { className: classes.root, variant: 'numeric' }, formattedValue)); };
    var renderLineOfSight = function () { return formattedValue
        ? React.createElement(VisibilityIcon, { fontSize: 'inherit' })
        : React.createElement(VisibilityOffIcon, { fontSize: 'inherit' }); };
    // const renderText = () => (
    //     <UIText className={classes.root} variant='body2'>{formattedValue}</UIText>
    // );
    var renderOrientation = function () { return switchUtil(value, {
        bottom: React.createElement(KeyboardArrowDownIcon, null),
        top: React.createElement(KeyboardArrowUpIcon, null),
        left: React.createElement(KeyboardArrowLeftIcon, null),
        right: React.createElement(KeyboardArrowRightIcon, null)
    }); };
    return switchUtil(variableName, {
        health: renderNumeric,
        actionTime: renderNumeric,
        position: renderNull,
        orientation: renderOrientation,
        duration: renderNumeric,
        rangeArea: renderNumeric,
        lineOfSight: renderLineOfSight,
        actionArea: renderNumeric,
        attack: renderNumeric
    })();
};
